<script setup lang="ts">

import { faTriangleExclamation } from '@fortawesome/pro-regular-svg-icons'

import { AppText } from '@shared/ui/typography'
import { AppSelectSearchable } from '@shared/ui/selects'
import { AppIcon } from '@shared/ui/icons'
import { AppBadge } from '@shared/ui/badges'

import LessonRecurringTutorOption from './LessonRecurringTutorOption.vue'
import { useLessonRecurringTutor } from '../../model/lessons/lesson-recurring-tutor.hook'

defineOptions({
  name: 'LessonRecurringTutor',
})

const {
  refTutorId,
  refTutorOptions,
  refIsTutorsLoading,
  refHasNoTutors,
  refIsSubmitting,
  refSelectedLabel,
  refTutorLabels,
} = useLessonRecurringTutor()
</script>

<template>
  <div
    v-if="refHasNoTutors"
    class="lesson-recurring-tutor__empty"
    role="status"
  >
    <AppIcon
      :icon="faTriangleExclamation"
      color="amber-500"
    />
    <div class="lesson-recurring-tutor__empty-content">
      <AppText
        name="body2-medium"
        color="slate-900"
      >
        No tutors found for these filters.
      </AppText>
      <AppText
        name="body2"
        color="slate-600"
      >
        Change the tutor filters or the schedule and confirm again.
      </AppText>
    </div>
  </div>
  <div
    v-else
    class="lesson-recurring-tutor"
  >
    <AppSelectSearchable
      v-model="refTutorId"
      :options="refTutorOptions"
      :loading="refIsTutorsLoading"
      :disabled="refIsSubmitting || refIsTutorsLoading"
      label="Tutor"
      placeholder="Select tutor"
    >
      <template #option="{ option, selected }">
        <LessonRecurringTutorOption
          :text="option.text"
          :selected="selected"
          :label="refTutorLabels.get(option.value)"
        />
      </template>
    </AppSelectSearchable>
    <AppBadge
      v-if="refSelectedLabel"
      class="lesson-recurring-tutor__availability"
      :color="refSelectedLabel.color"
      :text="refSelectedLabel.text"
    />
  </div>
</template>

<style scoped lang="scss" src="./LessonRecurringTutor.scss" />
